export default __webpack_public_path__ + "static/media/IconPuzzle.bfc5f3b8.png";